/*       */

import { gql } from '@apollo/client';
import { PUBLIC_TEAM_ID } from 'app/config/config';

/**
 * Unified query for searching workspace resources (class or entity) with data and count in a single request
 * Uses GraphQL aliases to fetch both paginated data and total count
 */
export const searchWorkspaceClassResourcesQuery = gql`
    query searchWorkspaceClassResources(
        $id: ID!
        $startIndex: Int
        $stopIndex: Int
        $searchQuery: String
        $ilikeSearchQuery: String
    ) {
        data: workspaceClassResources(
            startIndex: $startIndex
            stopIndex: $stopIndex
            filterBy: [
                { field: "workspace", op: "=", value: $id }
                { field: "class.active", op: "=", value: true }
                {
                    or: [
                        { field: "class", op: "startsWith", value: $searchQuery, cast: "text" }
                        { field: "class.name", op: "ilike", value: $ilikeSearchQuery }
                    ]
                }
            ]
        ) {
            role
            class {
                id
                name
                uri
            }
        }
        count: workspaceClassResources(
            filterBy: [
                { field: "workspace", op: "=", value: $id }
                { field: "class.active", op: "=", value: true }
                {
                    or: [
                        { field: "class", op: "startsWith", value: $searchQuery, cast: "text" }
                        { field: "class.name", op: "ilike", value: $ilikeSearchQuery }
                    ]
                }
            ]
        ) {
            role
        }
    }
`;

export const workspaceTeamMembersQuery = gql`
    query workspaceTeamMembersQuery(
        $id: ID!
        $startIndex: Int
        $stopIndex: Int
        $searchQuery: String
        $ilikeSearchQuery: String
    ) {
        data: workspaceTeamMembers(
            startIndex: $startIndex
            stopIndex: $stopIndex
            filterBy: [
                { field: "workspace", op: "=", value: $id }
                { field: "team.active", op: "=", value: true }
                {
                    or: [
                        { field: "team", op: "startsWith", value: $searchQuery, cast: "text" }
                        { field: "team.name", op: "ilike", value: $ilikeSearchQuery }
                    ]
                }
                {
                    or: [
                        { field: "team.id", op: "=", value: "${PUBLIC_TEAM_ID}" }
                        { field: "team.isSystem", op: "=", value: false }
                    ]
                }
            ]
        ) {
            role
            team {
                id
                name
                isSystem
            }
        }
        count: workspaceTeamMembers(
            filterBy: [
                { field: "workspace", op: "=", value: $id }
                { field: "team.active", op: "=", value: true }
                {
                    or: [
                        { field: "team", op: "startsWith", value: $searchQuery, cast: "text" }
                        { field: "team.name", op: "ilike", value: $ilikeSearchQuery }
                    ]
                }
                {
                    or: [
                        { field: "team.id", op: "=", value: "${PUBLIC_TEAM_ID}" }
                        { field: "team.isSystem", op: "=", value: false }
                    ]
                }
            ]
        ) {
            team {
                isSystem
            }
        }
    }
`;